import configDevelopment from './config-development.js';
import configStaging from './config-staging.js';
import configProduction from './config-production.js';
import configUAT from './config-uat.js';

let config = null;
const ENV = process.env.REACT_APP_BUILD_ENV;
console.log('ENV', ENV);

if (ENV === 'development') {
  config = configDevelopment;
} else if (ENV === 'staging') {
  config = configStaging;
} else if (ENV === 'production') {
  config = configProduction;
} else if (ENV === 'uat') {
  config = configUAT;
} else {
  config = configDevelopment;
}
export default config;

export const SERVICE_LINE_NAMES = {
  LABS: 'labs',
  PHARMACY: 'pharmacy',
  TELE: 'tele',
  DENTAL: 'dental',
  OFFLINE: 'offline',
  PREBOOK: 'prebook',
  SEARCHBOOK: 'searchAndBook',
  VISION: 'vision',
};

// Prod
export const ahcConditionalSponsorIds = {
  qualcommSponsorId: 11510,
  evokeSponsorId: 17475,
};

// Prod
export const claimsCategoryId = {
  ahcId: 28,
};
